// libraries
import React from 'react'
import clsx from 'clsx'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface TransportCardProps {
    title?: string
    intro?: string
    link?: {
        href: string
        external?: boolean
    }
    cardColor: 'beige' | 'green'
}

export default function TransportCard({
    title,
    intro,
    link,
    cardColor
}: TransportCardProps) {

    const Element = link ? 'a' : 'div'

    const elementProps = {
        href: link?.href || null,
        target: link?.external ? '_blank' : undefined,
        className: clsx(
            'transport-card',
            cardColor === 'beige' && 'transport-card--beige',
            cardColor === 'green' && 'transport-card--green'
        )
    }

    return (
        <Element {...elementProps}>
            <div className='transport-card__wrapper'>

                {isNonWhitespaceString(title) && (
                    <h3 className='transport-card__wrapper__title title-xs'>
                        {title}
                    </h3>
                )}

                {isNonWhitespaceString(intro) && (
                    <div
                        className='transport-card__wrapper__intro'
                        dangerouslySetInnerHTML={{ __html: intro }}
                        suppressHydrationWarning
                    />
                )}

                {link?.href && (
                    <div className='transport-card__wrapper__arrow'>
                        <svg width='19' height='17' viewBox='0 0 19 17' xmlns='http://www.w3.org/2000/svg'><path d='M10.75 16.33L9.34 14.91L15.09 9.16H0V7.16H15.09L9.34 1.41L10.75 0L18.91 8.16L10.75 16.33Z' fill='currentColor'/></svg>
                    </div>
                )}

            </div>
        </Element>
    )
}